let unauthorizedCallback = null;
let hasNotified = false;

export const registerUnauthorizedCallback = callback => {
  unauthorizedCallback = callback;
};

export const unregisterUnauthorizedCallback = () => {
  unauthorizedCallback = null;
};

export const notifyUnauthorized = () => {
  if (hasNotified || !unauthorizedCallback) {
    return;
  }

  hasNotified = true;
  unauthorizedCallback();
};

export const resetUnauthorizedHandling = () => {
  hasNotified = false;
};
